module.exports = __webpack_public_path__ + "img/quote-open.4a1ddc97.png";